import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userPhone, setUserPhone] = useState(() => localStorage.getItem('userPhone') || '');
  const [isVerified, setIsVerified] = useState(() => localStorage.getItem('isVerified') === 'true');
  const [user, setUser] = useState(null);

  useEffect(() => {
    localStorage.setItem('userPhone', userPhone);
  }, [userPhone]);

  useEffect(() => {
    localStorage.setItem('isVerified', isVerified);
  }, [isVerified]);

  const logout = () => {
    setUserPhone('');
    setIsVerified(false);
    localStorage.removeItem('userPhone');
    localStorage.removeItem('isVerified');
  };

  return (
    <UserContext.Provider value={{ user, setUser, userPhone, setUserPhone, isVerified, setIsVerified, logout }}>
      {children}
    </UserContext.Provider>
  );
};
